import { type DropdownItem } from '@/forms-legacy'
import { useMemo } from 'react'
import { useTexts } from './useTexts'

export function useOptions() {
  const texts = useTexts()

  return useMemo<DropdownItem[]>(() => {
    return optionsId.map(id => {
      switch (id) {
        case 'NO_REPEAT':
          return { id, label: texts.noRepeat }
        case 'DAILY':
          return { id, label: texts.daily }
        case 'WEEKLY':
          return { id, label: texts.weekly }
        case 'MONTHLY':
          return { id, label: texts.monthly }
        case 'ANNUALLY':
          return { id, label: texts.annually }
      }
    })
  }, [texts])
}

const optionsId = ['NO_REPEAT', 'DAILY', 'WEEKLY', 'MONTHLY', 'ANNUALLY'] as const
